if (!customElements.get('complementary-products')) {
  customElements.define(
    'complementary-products',
    class ComplementaryProducts extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (this.form) this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.cart = document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (this.submitButton && document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        if (this.querySelector('.complementary__actions')) {
          this.price = this.querySelector('.complementary__total__price');

          // ✅ FIX CLAVE:
          // Antes escuchabas solo inputs con data-available="true" y al cambiar a una variante agotada
          // dejabas de reaccionar bien.
          // Ahora escuchamos TODOS (select, input hidden, quantity).
          this.querySelectorAll('.select__select, input.complementary-variant-id, .quantity__input')
            .forEach((element) => {
              element.addEventListener('change', this.onChangeHandler.bind(this));
            });
        }

        // Forzamos un cálculo inicial para total/botón
        setTimeout(() => this.onChangeHandler({ target: this }), 0);
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton && this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        if (this.submitButton) {
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
        }
        const spinner = this.querySelector('.loading-overlay__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const config = fetchConfig('javascript');

        let formData = {};
        if (this.cart) {
          formData.sections = this.cart.getSectionsToRender().map((section) => section.id);
          formData.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }

        // Collection items
        let items = [];
        this.querySelectorAll('.complementary__item').forEach((item) => {
          const quantityInput = item.querySelector('.quantity__input');
          if (!quantityInput) return;

          const qty = parseInt(quantityInput.value || '0', 10);
          if (qty <= 0) return;

          // ✅ Soporta tanto hidden input como select de variantes
          const vEl = item.querySelector('.complementary-variant-id');
          if (!vEl) return;

          let chosen = vEl;
          if (vEl.classList.contains('select__select')) {
            chosen = vEl.querySelector('option:checked');
          }

          // ✅ Bloqueamos agregar si la variante está agotada
          // (así el cliente puede verla/seleccionarla pero no se añade al carrito)
          if (chosen && chosen.dataset && chosen.dataset.available === 'false') return;

          const variantId = chosen?.value || vEl.value;
          if (!variantId) return;

          items.push({
            id: variantId,
            quantity: qty,
          });
        });

        formData.items = items;
        config.body = JSON.stringify(formData);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton?.querySelector('.sold-out-message');
              if (soldOutMessage && this.submitButton) {
                this.submitButton.setAttribute('aria-disabled', true);
                const span = this.submitButton.querySelector('span');
                if (span) span.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
              }

              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            document.dispatchEvent(new CustomEvent('afterCartChanged'));
            this.cart.renderContents(response);
          })
          .catch((e) => console.error(e))
          .finally(() => {
            if (this.submitButton) this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (this.submitButton && !this.error) this.submitButton.removeAttribute('aria-disabled');
            if (spinner) spinner.classList.add('hidden');
          });
      }

      onChangeHandler(evt) {
        // Si cambió el select de variante: actualizar precio e imagen del item
        if (evt?.target?.classList?.contains('select__select')) {
          const currentItem = evt.target.closest('.complementary__item');
          const itemAttributeTag = evt.target.querySelector('option:checked');
          if (currentItem && itemAttributeTag) {
            this.updatePrice(
              currentItem.querySelector('.price'),
              parseInt(itemAttributeTag.dataset.price || '0', 10),
              parseInt(itemAttributeTag.dataset.compareAtPrice || '0', 10),
              true
            );

            const imageTag = currentItem.querySelector('img');
            if (imageTag) {
              if (itemAttributeTag.dataset.featuredImage) {
                let srcset = '';
                const imageWidth = parseInt(itemAttributeTag.dataset.featuredImageWidth || '0', 10);
                const originImageSrc = itemAttributeTag.dataset.featuredImage;
                const widths = [275, 550, 710, 1420];

                widths.forEach((width) => {
                  if (imageWidth >= width) srcset += `${originImageSrc}&width=${width} ${width}w,`;
                });

                srcset += `${originImageSrc} ${imageWidth}w`;
                imageTag.srcset = srcset;
                imageTag.classList.add('use-variant-image');
              } else if (imageTag.classList.contains('use-variant-image')) {
                imageTag.srcset = currentItem.dataset.featuredImage;
                imageTag.classList.remove('use-variant-image');
              }
            }
          }
        }

        // Recalcular total y activar/desactivar botón
        let totalPrice = 0,
          totalCompareAtPrice = 0,
          totalQuantity = 0;

        this.querySelectorAll('.complementary__item__info--variant').forEach((element) => {
          const variantTag = element.querySelector('.complementary-variant-id');
          if (!variantTag) return;

          let attributeTag = variantTag;
          if (variantTag.classList.contains('select__select')) {
            attributeTag = variantTag.querySelector('option:checked');
          }

          const input = element.querySelector('.quantity__input');
          const quantity = parseInt(input?.value || '0', 10);

          // ✅ Solo cuenta para el total si la variante está disponible
          if (attributeTag?.dataset?.available === 'true' && quantity > 0) {
            totalQuantity += quantity;
            totalPrice += parseInt(attributeTag.dataset.price || '0', 10) * quantity;
            totalCompareAtPrice += parseInt(attributeTag.dataset.compareAtPrice || '0', 10) * quantity;
          }
        });

        if (this.price) {
          this.updatePrice(this.price, totalPrice, totalCompareAtPrice, true);
        }

        if (this.submitButton) {
          if (totalQuantity > 0) {
            this.submitButton.removeAttribute('disabled');
          } else {
            this.submitButton.setAttribute('disabled', 'disabled');
          }
        }
      }

      // ✅ formateador COP con puntos (fallback)
      formatCOPFromCents(cents) {
        const n = Number(cents);
        if (!Number.isFinite(n)) return '$0';
        const pesos = Math.round(n / 100);
        const formatted = new Intl.NumberFormat('es-CO', {
          maximumFractionDigits: 0,
          minimumFractionDigits: 0,
        }).format(pesos);
        return `$${formatted}`;
      }

      // ✅ fallback cuando no existe priceElement.update()
      setPriceTextFallback(priceElement, price, compareAtPrice) {
        if (!priceElement) return;

        const regularSpan =
          priceElement.querySelector('.price__regular .price-item.price-item--regular') ||
          priceElement.querySelector('.price__regular .price-item') ||
          priceElement.querySelector('.price-item.price-item--regular');

        if (regularSpan) regularSpan.textContent = this.formatCOPFromCents(price);

        const saleSpan =
          priceElement.querySelector('.price__sale .price-item.price-item--sale') ||
          priceElement.querySelector('.price__sale .price-item');

        const compareSpan =
          priceElement.querySelector('.price__sale s.price-item.price-item--regular') ||
          priceElement.querySelector('.price__sale s.price-item') ||
          priceElement.querySelector('s.price-item.price-item--regular');

        const hasDiscount =
          Number.isFinite(Number(compareAtPrice)) &&
          Number.isFinite(Number(price)) &&
          Number(compareAtPrice) > Number(price);

        const saleWrap = priceElement.querySelector('.price__sale');
        const regWrap = priceElement.querySelector('.price__regular');

        if (hasDiscount) {
          if (saleSpan) saleSpan.textContent = this.formatCOPFromCents(price);
          if (compareSpan) compareSpan.textContent = this.formatCOPFromCents(compareAtPrice);
          if (saleWrap) saleWrap.style.display = '';
          if (regWrap) regWrap.style.display = 'none';
        } else {
          if (saleWrap) saleWrap.style.display = 'none';
          if (regWrap) regWrap.style.display = '';
        }
      }

      // ✅ Ya no crashea: soporta <product-price>, o un div.price, o fallback texto
      updatePrice(priceElement, price, compareAtPrice, noConvert) {
        if (!priceElement) return;

        if (typeof priceElement.update === 'function') {
          priceElement.update(price, compareAtPrice, noConvert);
          return;
        }

        const innerProductPrice = priceElement.querySelector?.('product-price');
        if (innerProductPrice && typeof innerProductPrice.update === 'function') {
          innerProductPrice.update(price, compareAtPrice, noConvert);
          return;
        }

        this.setPriceTextFallback(priceElement, price, compareAtPrice);
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;

        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) this.errorMessage.textContent = errorMessage;
      }
    }
  );
}
